export default __webpack_public_path__ + "static/media/sky_city@3x.f609c2c0.png";